import { render, staticRenderFns } from "./ContactCompany.vue?vue&type=template&id=13b13469&"
import script from "./ContactCompany.vue?vue&type=script&lang=js&"
export * from "./ContactCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports